export const ROOT_URL = "";

export const APP_NAME = "پل دیزاینــرز";
export const USER_TYPE = 1;
export const MESSENGER_TYPE = 2; // 2 => freelancer
export const MIN_DESKTOP_SIZE = 1280;
// export const FREELANCER_TOK = "freelancer_t";

export const IMAGE_URL = "/images/";
export const SERVICE_GUIDE_FILE = "https://poldesigners.com/helpfreelancerservices.pdf";

export const REQ_TYPES = {
    POST: "post",
    GET: "get",
    PUT: "put",
};

export const ADD_SERVICE_STEPS = {
    MAIN: 0,
    DROPDOWN_TYPES: 1,
    CHECKBOX_TYPES: 2,
    TEXT_TYPES: 3,
};


export const SERVICE_TYPES = {
    DROPDOWN_TYPE: {key: "DROPDOWN_TYPES", title: "لیست انتخابی", iconClasses: "icon-square-down-arrow"},
    CHECKBOX_TYPE: {key: "CHECKBOX_TYPES", title: "چک باکس", iconClasses: "icon-square-tick"},
    TEXT_TYPE: {key: "TEXT_TYPES", title: "مزیت خدمت", iconClasses: "icon-text"},
};


export const COLOR_PLATES = [
    {id: 1, color: "#FF7575", bgClassName: "bg-pol-red"},
    {id: 2, color: "#A8DB3C", bgClassName: "bg-pol-secondary-green-3"},
    {id: 3, color: "#5AEABF", bgClassName: "bg-pol-green"},
    {id: 4, color: "#C57CFF", bgClassName: "bg-pol-dark-pink"},
    {id: 5, color: "#FD73DF", bgClassName: "bg-pol-pink"},
];

export const MAX_FILE_SIZE = 1000 * 1000;

export const EDUCATIONAL_GRADES = [
    {name: "زیر دیپلم", value: "زیر دیپلم"},
    {name: "دیپلم", value: "دیپلم"},
    {name: "کاردانی", value: "کاردانی"},
    {name: "کارشناسی", value: "کارشناسی"},
    {name: "کارشناسی ارشد", value: "کارشناسی ارشد"},
    {name: "دکتری تخصصی", value: "دکتری تخصصی"},
];

export const EDUCATIONAL_STATUS = [
    {name: "در حال تحصیل", value: 0},
    {name: "فارغ التحصیل", value: 1},
];

export const SETTINGS_STATUS = [
    {name: "هیچکدام", value: 0},
    {name: "ایمیل", value: 1},
    {name: "پیامک و ایمیل", value: 2},
    {name: "پیامک", value: 3},
];

export const PRIORITY_ITEMS = [
    {value: 0, name: "کم اهمیت"},
    {value: 1, name: "متوسط"},
    {value: 2, name: "مهم"},
    {value: 3, name: "خیلی مهم"}
]

export const DEPARTMENT_ITEMS = [
    {value: 1, name: "دپارتمان فنی"},
    {value: 2, name: "دپارتمان مالی"},
    {value: 3, name: "پشتیبان ثبت نام"},
    {value: 4, name: "مدیریت"},
    {value: 5, name: "توسعه خلاق"},
    {value: 6, name: "روابط عمومی"},
    {value: 7, name: "دپارتمان مدیریت سفارشات"},
    {value: 8, name: "مرکز منتورینگ فریلنسری"},
]
